var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFullGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#full-glass_svg__clip0)",
    stroke: "#91C300",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.237 1.43c.285 0 .522.152.664.305.143.204.237.51.19.764l-5.504 41.38c-.047.458-.427.814-.854.814H10.72c-.428 0-.807-.356-.855-.814L4.362 2.499c-.047-.306.047-.56.19-.764a.907.907 0 01.664-.305h33.021z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5h32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "full-glass_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h43.59v50H0z"
  })))));
}

export default SvgFullGlass;